import { Action } from '@ngrx/store';
import { TMeasurementQcDB, TTransformedFetchBctxDetailsByPerPieceTagIdResponse } from '@monorepo/types';

export enum MeasurementQcDBActionTypes {
  InitializeMeasurementQcDB = 'InitializeMeasurementQcDB',
  SetMeasurementQcDB = 'SetMeasurementQcDB',
  MeasurementQcNoAction = 'MeasurementQcNoAction',
  IncreasePiecesMeasuredCountbySizeAndBctxKey = 'IncreasePiecesMeasuredCountbySizeAndBctxKey',
  UpdateBctxMap = 'UpdateBctxMap',
}

export class InitializeMeasurementQcDB implements Action {
  readonly type = MeasurementQcDBActionTypes.InitializeMeasurementQcDB;
  constructor() {}
}

export class SetMeasurementQcDB implements Action {
  readonly type = MeasurementQcDBActionTypes.SetMeasurementQcDB;
  constructor(public db: TMeasurementQcDB, public init: boolean = false) {}
}

export class IncreasePiecesMeasuredCountbySizeAndBctxKey implements Action {
  readonly type = MeasurementQcDBActionTypes.IncreasePiecesMeasuredCountbySizeAndBctxKey;
  constructor(public bctxKey: string, public tagSize: string) {}
}

export class UpdateBctxMap implements Action {
  readonly type = MeasurementQcDBActionTypes.UpdateBctxMap;
  constructor(
    public bctxKey: string,
    public updatedData: TTransformedFetchBctxDetailsByPerPieceTagIdResponse,
    public isThisLastFetchedTag: boolean,
  ) {}
}

export class MeasurementQcNoAction implements Action {
  readonly type = MeasurementQcDBActionTypes.MeasurementQcNoAction;
  constructor() {}
}

export type TMeasurementQcActions =
  | InitializeMeasurementQcDB
  | MeasurementQcNoAction
  | SetMeasurementQcDB
  | IncreasePiecesMeasuredCountbySizeAndBctxKey
  | UpdateBctxMap;
